
export const fbq = window.fbq = function fbq() {
  fbq.callMethod ?
      fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments)
};

if (!window._fbq) window._fbq = fbq;
fbq.push = fbq;
fbq.loaded = !0;
fbq.version = '2.0';
fbq.queue = [];

function script(src) {
  const t = document.createElement("script");
  t.async = true;
  t.src = src;
  document.body.appendChild(t);
}

script("https://connect.facebook.net/en_US/fbevents.js");

script("https://www.googletagmanager.com/gtag/js?id=UA-3595668-1");

const dataLayer = window.dataLayer = window.dataLayer || [];

export function gtag() { dataLayer.push(arguments); }

gtag('js', new Date());
